export default "/images/36247275613a62418f53460950bd0b99.avif";